// Authentication Methods - Centralized constants for auth tracking
export const AUTH_METHODS = {
	EMAIL: "email",
	GOOGLE: "google",
	GITHUB: "github",
	MICROSOFT: "microsoft",
	OAUTH_PENDING: "oauth_pending",
	TOTP: "totp",
} as const;

export const AUTH_SOURCES = {
	DIRECT: "direct",
	EMAIL: "email",
	ORGANIC: "organic",
	REFERRAL: "referral",
	CAMPAIGN: "campaign",
	INTEGRATION: "integration",
} as const;

export type AuthMethod = (typeof AUTH_METHODS)[keyof typeof AUTH_METHODS];
export type AuthSource = (typeof AUTH_SOURCES)[keyof typeof AUTH_SOURCES];
